import { ReactNode } from 'react';

interface SettingsToggleProps {
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  icon?: ReactNode;
  disabled?: boolean;
}

export default function SettingsToggle({
  label,
  description,
  checked,
  onChange,
  icon,
  disabled = false
}: SettingsToggleProps) {
  return (
    <label className={`flex items-start gap-4 ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} group`}>
      {icon && (
        <div className="mt-1 text-recipe-text-muted group-hover:text-recipe-accent transition-colors">
          {icon}
        </div>
      )}
      <div className="flex-1">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <span className="block text-sm font-medium text-recipe-text">
              {label}
            </span>
            {description && (
              <span className="text-xs text-recipe-text-muted mt-1 block">
                {description}
              </span>
            )}
          </div>
          <div className="ml-4">
            <button
              type="button"
              role="switch"
              aria-checked={checked}
              disabled={disabled}
              onClick={() => !disabled && onChange(!checked)}
              className={`
                relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ease-in-out
                focus:outline-none focus:ring-2 focus:ring-recipe-accent/50 focus:ring-offset-2 focus:ring-offset-recipe-card
                ${checked ? 'bg-recipe-accent' : 'bg-recipe-border'}
                ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
              `}
            >
              <span
                className={`
                  inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ease-in-out
                  ${checked ? 'translate-x-6' : 'translate-x-1'}
                `}
              />
            </button>
          </div>
        </div>
      </div>
    </label>
  );
}
